import React from 'react';
import { SurveyMainType } from '../../types/SurveyMainType';
import { SurveyQuestionType } from '../../types/SurveyQuestionType';
import { GenerateQuestion } from './GenerateQuestion';

interface ISurveyLabelProps {
    question: SurveyQuestionType;
    pppData?: React.Dispatch<React.SetStateAction<SurveyMainType | undefined>>;
    errorIds?: number[];
}

const SurveyLabel = ({
    question,
    pppData,
    errorIds
} : ISurveyLabelProps) => {
    return (
        <>
        <hr className='hrMargin2' />

        <p className="bold red">
            {question.text}
        </p>

        {question.subQuestions ? (
            question.subQuestions.map((subQuestion) => {
                return <GenerateQuestion question={subQuestion} pppData={pppData} />
            })

            
        ) : null}
    </>
    );
};

export {
    SurveyLabel
}